// import { useEffect, useState } from "react"

import { Output as OutputLabel } from './product_Label';
// import { Output as OutputLabel } from './deliveryOrder_Label';

export function Output(props) {

    const { pageVariants } = props

    // console.log('props', props, data)

    if (pageVariants?.renderDataType === "label") {
        return OutputLabel(props)
    }

    // return OutputLabel(props)

    // console.log('error render data type')

    // return <></>
}